import classnames from "classnames";

import { PRICING_TABLE, BLOCKS_IS_HIGHLIGHTED } from "utils/constants/ui";

export const getGridClass = ({ suffix, isEmphasized }) =>
  classnames(`${PRICING_TABLE}__${suffix}`, {
    [BLOCKS_IS_HIGHLIGHTED]: isEmphasized
  });
